<!-- Incomplete Task View - Show when status is 4 (WindowClosed) -->
<div class="incomplete-task-container" *ngIf="processTaskData?.status === 4">
  <img
    src="assets/images/incomplete-task.jpg"
    alt="Incomplete Task"
    class="incomplete-task-image"
  />
</div>

<!-- Task Available Soon View - Show when startDateTime is greater than current time -->
<div
  class="incomplete-task-container"
  *ngIf="isTaskClosed && processTaskData?.status !== 4"
>
  <img
    src="assets/images/task-close.jpg"
    alt="Task Available Soon"
    class="incomplete-task-image"
  />
  <div class="available-soon-content">
    <h2 class="available-soon-title">Available Soon</h2>
    <p class="available-soon-text">
      This task will be available at
      {{ processTaskData?.startDateTime | date: "hh:mm a":"UTC" }}. Please come
      back at the scheduled time.
    </p>
  </div>
</div>

<!-- Form View - Show when not hidden and no data exists -->
<div
  class="observation-container"
  *ngIf="isFormView && processTaskData?.status !== 4 && !isTaskClosed"
>
  <div class="previous-remarks" *ngIf="previousRemarks?.length">
    <h3 class="previous-remarks-title">Audit Rejected Reason</h3>

    <div class="previous-remark-card" *ngFor="let item of previousRemarks">
      <div class="previous-remark-header">
        <span class="previous-remark-author">
          {{ item?.updatedBy?.name || "N/A" }}
        </span>
        <span class="previous-remark-meta">
          rejected the task and submitted a remark
        </span>
      </div>

      <p class="previous-remark-text">
        {{ item?.data?.auditRemark || "-" }}
      </p>

      <div class="previous-remark-footer">
        <span class="previous-remark-date">
          {{ item?.createdAt | date: "dd MMM yyyy hh:mm a" }}
        </span>
      </div>
    </div>
  </div>

  <form [formGroup]="observationForm">
    <!-- Observation Notes -->
    <div class="form-field">
      <label class="field-label">
        Observation Notes
        <span
          class="required-asterisk"
          *ngIf="processTaskData?.isObservationNotesRequired"
          >*</span
        >
      </label>
      <textarea
        formControlName="observationNotes"
        placeholder="Type Observation Notes"
        rows="4"
        class="observation-textarea"
      ></textarea>
      <mat-error
        *ngIf="
          observationForm.get('observationNotes')?.touched &&
          observationForm.get('observationNotes')?.hasError('required')
        "
      >
        Observation notes are required
      </mat-error>
    </div>

    <!-- File Upload Area -->
    <div class="form-field">
      <label class="field-label" *ngIf="processTaskData?.isFileUploadRequired">
        Upload Files <span class="required-asterisk">*</span>
      </label>
      <div
        class="upload-area"
        [class.dragging]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()"
      >
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text">Click and Upload your File here</p>
        <p class="upload-subtext">
          PNG, JPG, JPEG, PDF, CSV, DOC, DOCX up to 5MB
        </p>
        <input
          #fileInput
          type="file"
          multiple
          accept="image/png,
                  image/jpg,
                  image/jpeg,
                  application/pdf,
                  application/msword,
                  application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                  text/csv,
                  video/*"
          (change)="onFileSelect($event)"
          class="hidden-input"
        />
      </div>
      <mat-error
        *ngIf="
          processTaskData?.isFileUploadRequired &&
          filePreviewUrls.length === 0 &&
          observationForm.touched
        "
      >
        File upload is required
      </mat-error>
    </div>

    <!-- Uploaded Files List -->
    <div
      class="uploaded-files"
      *ngIf="uploadedFiles.length > 0 || filePreviewUrls.length > 0"
    >
      <div
        class="attachment-card"
        *ngFor="let file of filePreviewUrls.slice(0, 3); let i = index"
      >
        <div class="attachment-preview" (click)="viewMedia(file)">
          <img
            *ngIf="file?.fileType === 'image'"
            [src]="file.dataURI"
            alt="Uploaded media"
            class="media-item"
          />
          <div
            *ngIf="
              ['pdf', 'doc', 'csv', 'file', 'video'].includes(
                file?.fileType || ''
              )
            "
            class="media-preview"
          >
            <mat-icon
              class="mat-icon-file"
              [svgIcon]="getFileIcon(file.fileType)"
            ></mat-icon>
            <p
              class="observation-file-name"
              #formFileName
              [matTooltip]="getTooltip(formFileName)"
            >
              {{ file.name }}
            </p>
          </div>
        </div>
        <span class="attachment-timestamp" *ngIf="file.createdAt">
          {{ file.createdAt | date: "dd MMM yyyy, hh:mm a" }}
        </span>
      </div>
      <span
        *ngIf="filePreviewUrls.length > 3"
        class="upload-count"
        (click)="viewMedia('')"
      >
        +{{ filePreviewUrls.length - 3 }} <br />
        View All
      </span>

      <!-- <div class="file-item" *ngFor="let file of filePreviewUrls; let i = index">
        <img [src]="file.dataURI" alt="Preview" class="file-preview" />
       
      </div> -->
    </div>

    <!-- Radio Button - Was There any problem? -->
    <div class="form-field form-field-radio">
      <label class="field-label">Was There any problem?</label>
      <mat-radio-group formControlName="issueFound" class="radio-group">
        <mat-radio-button [value]="true" class="radio-option"
          >Yes</mat-radio-button
        >
        <mat-radio-button [value]="false" class="radio-option"
          >No</mat-radio-button
        >
      </mat-radio-group>
      <mat-error
        *ngIf="
          observationForm.get('issueFound')?.touched &&
          observationForm.get('issueFound')?.hasError('required')
        "
      >
        Please select an option
      </mat-error>
    </div>

    <!-- Remarks -->
    <div class="form-field remarks-field">
      <label class="field-label">
        Remark
        <span
          class="required-asterisk"
          *ngIf="observationForm.get('issueFound')?.value === true"
          >*</span
        >
      </label>
      <textarea
        formControlName="remark"
        placeholder="Type remark"
        rows="4"
        class="remarks-input"
      ></textarea>
      <mat-error
        *ngIf="
          observationForm.get('remark')?.touched &&
          observationForm.get('remark')?.hasError('required')
        "
      >
        Remark is required when problem is found
      </mat-error>
    </div>
  </form>
</div>

<!-- Detail View - Show when not hidden and data exists -->
<div
  class="observation-detail"
  *ngIf="isDetailView && processTaskData?.status !== 4 && !isTaskClosed"
>
  <!-- Observation Notes -->
  <div class="detail-section">
    <h3 class="detail-label">Observation Notes</h3>
    <p class="detail-text" *ngIf="observationData?.observationNotes">
      {{ observationData?.observationNotes }}
    </p>
    <p class="detail-text-empty" *ngIf="!observationData?.observationNotes">
      No data provided
    </p>
  </div>

  <!-- Uploaded Media -->
  <div class="detail-section">
    <h3 class="detail-label">Uploaded Media</h3>

    <!-- Add attachments after task completion -->
    <div class="form-field" *ngIf="canAddAttachments">
      <div
        class="upload-area upload-area-compact"
        [class.dragging]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="detailFileInput.click()"
      >
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text">
          {{ isUploadingAttachments ? "Uploading..." : "Add more files" }}
        </p>
        <p class="upload-subtext">PNG, JPG, JPEG, PDF, CSV, DOC, DOCX, Video</p>
        <input
          #detailFileInput
          type="file"
          multiple
          accept="image/png,
                  image/jpg,
                  image/jpeg,
                  application/pdf,
                  application/msword,
                  application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                  text/csv,
                  video/*"
          (change)="onDetailFileSelect($event)"
          class="hidden-input"
        />
      </div>
    </div>

    <div
      class="media-grid detail-media-grid"
      *ngIf="
        (observationData?.attachments?.length ?? 0) > 0 ||
        filePreviewUrls.length > 0
      "
    >
      <ng-container
        *ngFor="let file of filePreviewUrls.slice(0, 3); let i = index"
      >
        <div class="attachment-card">
          <div class="attachment-preview" (click)="viewMedia(file)">
            <img
              *ngIf="file?.fileType === 'image'"
              [src]="sanitizeUrl(file.url || file.dataURI)"
              alt="Uploaded media"
              class="media-item"
            />
            <div
              *ngIf="
                ['pdf', 'doc', 'csv', 'file', 'video'].includes(
                  file?.fileType || ''
                )
              "
              class="media-preview"
            >
              <mat-icon
                class="mat-icon-file"
                [svgIcon]="getFileIcon(file.fileType)"
              ></mat-icon>
              <p
                class="observation-file-name"
                #fileName
                [matTooltip]="getTooltip(fileName)"
              >
                {{ file.name }}
              </p>
            </div>
          </div>
          <span class="attachment-timestamp" *ngIf="file.createdAt">
            {{ file.createdAt | date: "dd MMM yyyy, hh:mm a" }}
          </span>
        </div>
      </ng-container>
      <span
        *ngIf="filePreviewUrls.length > 3"
        class="upload-count"
        (click)="viewMedia('')"
      >
        +{{ filePreviewUrls.length - 3 }} <br />
        View All
      </span>
    </div>
    <p
      class="detail-text-empty"
      *ngIf="!observationData?.attachments?.length && !filePreviewUrls.length"
    >
      No data provided
    </p>
  </div>

  <!-- Remark -->
  <div class="detail-section">
    <h3 class="detail-label">Remark</h3>
    <p class="detail-text" *ngIf="observationData?.remark">
      {{ observationData?.remark }}
    </p>
    <p class="detail-text-empty" *ngIf="!observationData?.remark">
      No data provided
    </p>
  </div>

  <div class="previous-remarks" *ngIf="previousRemarks?.length">
    <h3 class="previous-remarks-title">Audit Rejected Reason</h3>

    <div class="previous-remark-card" *ngFor="let item of previousRemarks">
      <div class="previous-remark-header">
        <span class="previous-remark-author">
          {{ item?.updatedBy?.name || "N/A" }}
        </span>
        <span class="previous-remark-meta">
          rejected a task and submitted remark
        </span>
      </div>

      <p class="previous-remark-text">
        {{ item?.data?.auditRemark || "-" }}
      </p>

      <div class="previous-remark-footer">
        <span class="previous-remark-date">
          {{ item?.createdAt | date: "dd MMM yyyy hh:mm a" }}
        </span>
      </div>
    </div>
  </div>
</div>
